import styled from 'styled-components';
import ScrollContainer from 'react-indiana-drag-scroll';

export const Container = styled(ScrollContainer)`
  display: flex;
  width: 100%;
  max-width: 1560px;
  padding-left: 100px;

  @media (max-width: 1366px) {
    padding-left: 40px;
  }

  .case {
    cursor: pointer;
    text-decoration: none;
    margin-right: 50px;
    padding: 20px;
    border-radius: 10px;
    border: 2px solid #5eeddc;
    transition: opacity 0.4s;

    span {
      display: block;

      & + span {
        margin-top: 20px;
      }
    }

    &:hover {
      opacity: 0.6;
    }

    .case-details {
      width: 20vw;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      box-sizing: border-box;

      @media (max-width: 1366px) {
        width: 27vw;
      }

      @media (max-width: 768px) {
        width: 40vw;
      }

      @media (max-width: 640px) {
        width: 45vw;
      }

      h2 {
        font-family: 'Avenir Next LT Pro Bold';
        font-size: 1.5rem;
        color: #fff;

        @media (max-width: 1366px) {
          font-size: 1.2rem;
        }
      }

      p {
        font-size: 16px;
        margin: 10px 0;

        @media (max-width: 1366px) {
          font-size: 14px;
          margin: 5px 0;
        }
      }

      span {
        font-family: 'Avenir Next LT Pro Regular';
        font-size: 14px;
        color: #5eeddc;
      }

      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .stars {
          display: flex;
          color: #fff;

          svg {
            margin: 0 5px;
          }
        }
      }
    }
  }
`;
